import { render } from "./windowHeader.vue?vue&type=template&id=6e5b8f56&scoped=true"
import script from "./windowHeader.vue?vue&type=script&lang=js"
export * from "./windowHeader.vue?vue&type=script&lang=js"

import "./windowHeader.vue?vue&type=style&index=0&id=6e5b8f56&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e5b8f56"

export default script